
import React, {useState, useEffect} from "react";
import { 
        // MenuItem, 
        FormControl, 
        // Select, 
        Card, 
        CardContent, 
        Button
      } from '@material-ui/core';
import './App.css';
import InfoBox from "./InfoBox";
import InfoBoxSmall from "./InfoBoxSmall";
import Map from "./Map";
import numeral from "numeral";
import Table from "./Table";
import { sortData } from "./util";
import LineGraph from "./LineGraph";
import CentredChart from "./CentredChart";
import "leaflet/dist/leaflet.css";
import SelectSearch from 'react-select-search';
import logo from './assets/logo.png'; 
import contactUsImage from './assets/ContactUs.png'; 

function App() {
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("worldwide");
  const [updatedDate, setUpdatedDate] = useState("");
  const [countryInfo, setCountryInfo] = useState({});
  const [mapCountries, setMapCountries] = useState([]);
  const [searchCountry, setSearchCountry] = useState([{name: 'Worldwide', value: 'worldwide'}]);
  const [TableData, setTableData] = useState([]);
  // const [mapCenter, setMapCenter] = useState({ lat: 21.3891, lng: 39.8579 });
  // const [mapZoom, setMapZoom] = useState(2);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -29 });
  const [mapZoom, setMapZoom] = useState(3);
  const [casesType, setCasesType] = useState("cases");
  const [pastCases, setpastCases] = useState([0,0]);
  const [pastRecovered, setpastRecovered] = useState([0,0]);
  const [pastDeaths, setpastDeaths] = useState([0,0]);
  const [showContactUs, setshowContactUs] = useState(false);
  const [supportMessage, setSupportMessage] = useState(false);
  const [showhamMenus, setShowhamMenus] = useState(false);
  

  //Get list of countries to fill in the select
  useEffect(() => {
    
    const getCountriesData = async() => {
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response)=> response.json())
      .then((data)=> {
        const countries = data.map((country) => (
          {
            name: country.country,
            value: country.countryInfo.iso2
          }
        ))
        const sortedData = sortData(data);

        const filteredDataSorted = sortedData.filter((dt) => { return dt.country !== "Western Sahara"; }); 
        setTableData(filteredDataSorted);

        const filteredData = data.filter((dt) => { return dt.country !== "Western Sahara"; }); 
        setMapCountries(filteredData);

        const filteredCountries = countries.filter((cntr) => { return cntr.name !== "Western Sahara"; }); 
        setCountries(filteredCountries);
      })
    }
    getCountriesData();
  }, []);

  useEffect(() => {
    const getTotalCasesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/all")
      .then((response)=> response.json())
      .then((data) => {
        setCountryInfo(data);
      })
    }
    getTotalCasesData();
  }, [])

  // New select with search get data of selected option
  useEffect(() => {
    const getCountryChangeHandler = async () => {
    const countryCode = country;
    
    const url = countryCode === 'worldwide' ? 'https://disease.sh/v3/covid-19/all'
                                            : `https://disease.sh/v3/covid-19/countries/${countryCode}`

    await fetch(url)
    .then((response)=> response.json())
      .then((data) => {
        setCountry(countryCode);
        setCountryInfo(data);
        if(countryCode === 'worldwide'){
          setMapCenter({ lat: 34.80746, lng: -29 })
        }
        else{
          setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        }
        setMapZoom(4);
        setUpdatedDate("(Last update : "+new Date(data.updated).toISOString().split(".")[0].replace("T", " ")+")");
      })
    }
    getCountryChangeHandler();
  }, [country])

  // Old select without search
  // const onCountryChange = async (event) => {
  //   const countryCode = event.target.value;
  //   const url = countryCode === 'worldwide' ? 'https://disease.sh/v3/covid-19/all'
  //                                           : `https://disease.sh/v3/covid-19/countries/${countryCode}`

  //   await fetch(url)
  //   .then((response)=> response.json())
  //     .then((data) => {
  //       setCountry(countryCode);
  //       setCountryInfo(data);

  //       setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
  //       setMapZoom(4);
  //     })
  // }

  useEffect(() => {
    setSearchCountry([{name: 'Worldwide', value: 'worldwide'}]);
    countries.map(
      country => 
        setSearchCountry(oldArray => [...oldArray, {name: country.name, value: country.value}])
    )
  }, [countries])

  const showOverLayDonate = () => {
    setSupportMessage(true);
    window.open("https://paypal.me/BenMalki", "_blank");
  }


  return (
    <div className="App">
      {
        supportMessage? (
          <div className="app__overlayDonate">
            <div className="app__overlayTextDonate">
              <h1>Thank you!</h1>
              <br/>
              <h3>You are awesome...</h3>
              <div className="app__contactus__footer">
                <Button variant="contained" color="primary" onClick={()=>(setSupportMessage(false))}>
                  Close
                </Button>
                {/* <button className="app__donate__footer__close"  onClick={()=>(setSupportMessage(false))}>
                  Close
                </button> */}
              </div>
            </div>
          </div>
        )
        : null
      }
      {
        showContactUs? (
          <div className="app__overlayContactUs">
          {/* <div className="app__overlayText"><h1>Contacting</h1></div> */}
          <div className="app__contactus__root">
            <div className="app__contactus__header">
              <h1>Contact us</h1>
            </div>
            <div className="app__contactus__body">
              <div className="app__contactus__body__left">
                <p className="app__contactus__body__left__highlitedText">Need a hand? Or a high five?</p>
                <p className="app__contactus__body__left__highlitedText">Here’s how to reach us.</p>
                <b>E-mail: </b><p>benyamine.malki@gmail.com</p>
                <b>Phone: </b><p>+212 6 22 73 10 80</p>
              </div>
              <div className="app__contactus__body__right">
                <img
                  className="app__contactus__body__right__img"
                  src={contactUsImage}
                  alt="Contact us"
                />
              </div>
            </div>
            <div className="app__contactus__footer">
                <Button variant="contained" color="primary" onClick={()=>(setshowContactUs(false))}>
                  Close
                </Button>
              {/* <button className="app__contactus__footer__close" onClick={()=>(setshowContactUs(false))}>
                Close
              </button> */}
            </div>
          </div>
          </div>
        )
        : null
      }
      <div className="app__header__top">
        <img
          className="app__headerImage"
          src={logo}
          alt="COVID-19 logo"
          onClick={()=>( setShowhamMenus(false))}
        />
        <FormControl className="app___dropdown" onClick={()=>( setShowhamMenus(false))}>
          <SelectSearch options={searchCountry}
            onChange={setCountry}
            name="language"
            search={true}
            placeholder="Choose a country"
            emptyMessage={() => <div style={{ textAlign: 'center', fontSize: '0.8em' }}>Not found</div>}
          />
        </FormControl>
         <div className="app__loginContent">
            <Button variant="contained" color="secondary"  onClick={()=>(showOverLayDonate())}>Donate</Button>
            <Button variant="contained" color="primary" onClick={()=>(setshowContactUs(true))}>Contact us</Button>
            <div className="myLinksCcntainer" onClick={()=>(showhamMenus === false ? setShowhamMenus(true) : setShowhamMenus(false))}>
                <div className="myLinksCcntainerDiv"></div>
                <div className="myLinksCcntainerDiv"></div>
                <div className="myLinksCcntainerDiv"></div>
                {
                  showhamMenus === true ? (
                    <div className="myLinksCcntainerButtons">
                      <div onClick={()=>(showOverLayDonate())}>Donate</div>
                      <div onClick={()=>(setshowContactUs(true))}>Contact us</div>
                    </div>
                  ) :
                    null
                }
            </div>
          </div>
      </div>
      <div className="App_Body"  onClick={()=>( setShowhamMenus(false))}>
        <div className="app__left">
          <div className="app__header">
            <h1>Coronavirus Worldometer</h1>
            {/* <FormControl className="app___dropdown"> */}
              {/* <Select
                variant="outlined"
                value={country}
                onChange={onCountryChange}
              >
                <MenuItem value="worldwide">Worldwide</MenuItem>
                {
                  countries.map(
                    country => (
                      <MenuItem value={country.value}>{country.name}</MenuItem>
                    )
                  )
                }
              </Select> */}
            {/* </FormControl> */}
          </div>
          <div className='app__stats'>
            
                {/* <InfoBox title="Coronavirus cases" cases={countryInfo.todayCases} total={countryInfo.cases}/>
                <InfoBox title="Recovered" cases={countryInfo.todayRecovered} total={countryInfo.recovered}/>
                <InfoBox title="Deaths" cases={countryInfo.todayDeaths} total={countryInfo.deaths}/> */}

            {/* InfoBox with k and Mnew design */}
            {/* <InfoBox
              onClick={(e) => setCasesType("cases")}
              title="New"
              isRed
              active={casesType === "cases"}
              cases={prettyPrintStat(countryInfo.todayCases)}
              total={numeral(countryInfo.cases).format("0.0a")}
            />
            <InfoBox
              onClick={(e) => setCasesType("recovered")}
              title="Recovered"
              active={casesType === "recovered"}
              cases={prettyPrintStat(countryInfo.todayRecovered)}
              total={numeral(countryInfo.recovered).format("0.0a")}
            />
            <InfoBox
              onClick={(e) => setCasesType("deaths")}
              title="Deaths"
              isBlack
              active={casesType === "deaths"}
              cases={prettyPrintStat(countryInfo.todayDeaths)}
              total={numeral(countryInfo.deaths).format("0.0a")}
            /> */}
            <p>COVID-19 CORONAVIRUS PANDEMIC for 
              <b>{countryInfo.country?.length > 0 ? " " + countryInfo.country.toUpperCase()  + " " : " Worldwide ".toUpperCase()}</b>
              <i>{updatedDate}</i></p>
            <div className="app__firstlineinfo">
              <InfoBox
                onClick={(e) => setCasesType("cases")}
                title="Today New Cases"
                isRed
                yesterday={numeral(pastCases[0]).format("0,0")}
                twoDaysAgo={numeral(pastCases[1]).format("0,0")}
                active={casesType === "cases"}
                cases={numeral(countryInfo.todayCases).format("0,0")}
                total={ numeral(countryInfo.cases).format("0,0")}
                secondSubTitletext="Cases Per One Million :"
                secondSubTitletextValue={numeral(countryInfo.casesPerOneMillion).format("0,0")}
              />
              <InfoBox
                onClick={(e) => setCasesType("recovered")}
                title="Today Recovered Cases"
                yesterday={numeral(pastRecovered[0]).format("0,0")}
                twoDaysAgo={numeral(pastRecovered[1]).format("0,0")}
                active={casesType === "recovered"}
                cases={numeral(countryInfo.todayRecovered).format("0,0")}
                total={numeral(countryInfo.recovered).format("0,0")}
                secondSubTitletext="Recovered Per One Million :"
                secondSubTitletextValue={numeral(countryInfo.recoveredPerOneMillion).format("0,0")}
              />
              <InfoBox
                onClick={(e) => setCasesType("deaths")}
                title="Today Deaths Cases"
                yesterday={numeral(pastDeaths[0]).format("0,0")}
                twoDaysAgo={numeral(pastDeaths[1]).format("0,0")}
                isBlack
                active={casesType === "deaths"}
                cases={numeral(countryInfo.todayDeaths).format("0,0")}
                total={numeral(countryInfo.deaths).format("0,0")}
                secondSubTitletext="Deaths Per One Million :"
                secondSubTitletextValue={numeral(countryInfo.deathsPerOneMillion).format("0,0")}
              />
            </div>
            <div className="app__secondlineinfo">
              <InfoBoxSmall
                isActive
                onClick={(e) => setCasesType("active")}
                active={casesType === "active"}
                title="Active Cases:"
                cases={numeral(countryInfo.active).format("0,0")}
                titlePerOne="Active Per One Million : "
                casesPerOne={numeral(countryInfo.activePerOneMillion).format("0,0")}
              />
              <InfoBoxSmall
                isCritical
                onClick={(e) => setCasesType("critical")}
                active={casesType === "critical"}
                title="Critical Cases:"
                cases={numeral(countryInfo.critical).format("0,0")}
                titlePerOne="Critical Per One Million : "
                casesPerOne={numeral(countryInfo.criticalPerOneMillion).format("0,0")}
              />
              <InfoBoxSmall
                isTests
                onClick={(e) => setCasesType("tests")}
                active={casesType === "tests"}
                title="Tests:"
                cases={numeral(countryInfo.tests).format("0,0")}
                titlePerOne="Tests Per One Million : "
                casesPerOne={numeral(countryInfo.testsPerOneMillion).format("0,0")}
              />
            </div>
          </div>
          <Map
            countries={mapCountries}
            casesType={casesType}
            center={mapCenter}
            zoom={mapZoom}
          />
          <div className="app__graph__central" >
            <h3 className="app__graph__central__title">{countryInfo.country?.length > 0 ? countryInfo.country : " Worldwide "} New Cases over time</h3>
            <CentredChart casesType="cases" diff="yes" countrySelected={country} setpastCases={setpastCases} setpastRecovered={setpastRecovered} setpastDeaths={setpastDeaths} />
          </div>
          <div className="app__graph__central" >
            <h3 className="app__graph__central__title">{countryInfo.country?.length > 0 ? countryInfo.country : " Worldwide "} Total Cases over time</h3>
            <CentredChart casesType="cases" countrySelected={country} />
          </div>

        </div>
        <Card className="app__right">
            <CardContent>
              <h3>Worldwide Live Cases</h3>
              <>
              <Table countries={TableData} />
              </>
              <h3 className="app__wordwidetext">Worldwide Evolution Cases</h3>
              <LineGraph className="app__graph" casesType="cases"  />

              <h3 className="app__wordwidetext">Worldwide Evolution Recovered</h3>
              <LineGraph className="app__graph" casesType="recovered" />

              <h3 className="app__wordwidetext">Worldwide Evolution Deaths</h3>
              <LineGraph className="app__graph" casesType="deaths" />
            </CardContent>
        </Card>
      </div>
      <div className="App_footer"  onClick={()=>( setShowhamMenus(false))}>
          <p>Copyrights © {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}

export default App;
